export interface DynamicPages{
    id:number,
    title:string,
    type:pageType,
    url:string
}


export interface DynamicSearchObject{
    toAirportCode :string,
    toAirport:string,
    fromAirport:string,
    fromAirportCode:string,
    content:string,
    createdDate:string,
    id:number,
    type:pageType,
    title:string,
    name:string,
    metaTitle:string,
    metaKeywords:string,
    metaDescription:string,
    language:string,
    image:string

}

export interface DynamicSearchDetailResponse{
    status:boolean,
    message:string,
    data:DynamicSearchObject[]
}

export interface DynamiPageResponse{
    status:boolean,
    message:string,
    data:DynamicPages[]
}

export enum pageType{
    Location = "Location",
    Country = "Country",
    Airline = "Airline",
    Blog = "Blog"
}


